module.exports = __webpack_public_path__ + "json/cv.json?dd2271840d59033832a12ec14629490d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/cv.json
// module id = 274
// module chunks = 0